module.exports = __webpack_public_path__ + "media/images/icon-reflexive-78d5ec86c0d0bfdee4d9bfc4ffccdbf5.svg";